import styled from 'styled-components'
import PropTypes from 'prop-types'
import { css, get } from '@styled-system/css'
import color from '@styled-system/color'
import space from '@styled-system/space'
import propTypes from '@styled-system/prop-types'
import shouldForwardProp from '@styled-system/should-forward-prop'

const themeTransform = (obj, theme) => (obj ? css(obj)(theme) : undefined)

const baseStyles = {
  boxSizing: 'border-box',
  minWidth: 0,
}

const baseCss = ({ theme, __css: obj }) => themeTransform(obj, theme)
const publicCss = ({ theme, css: obj }) => themeTransform(obj, theme)

const variant = ({ theme, variant, variantPath }) => {
  if (!variant) {
    return
  }
  const prefixedPath = `${variantPath}.${variant}`
  const variantObj = get(theme, prefixedPath, get(theme, variant))

  return themeTransform(variantObj, theme)
}

export const Box = styled('div')
  .withConfig({
    shouldForwardProp
  })(
    baseStyles,
    baseCss,
    variant,
    publicCss,
    color,
    space,
  )

Box.displayName = 'Box'

Box.propTypes = {
  /** base styles, intended to be used only when extending component */
  __css: PropTypes.object,
  /** styles applied after base & variant, intended for inline usage */
  css: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  /** optional variant of a component */
  variant: PropTypes.string,
  /** optional path to the component's variant definition in theme */
  variantPath: PropTypes.string,
  /** styled-system propTypes */
  ...propTypes.color,
  ...propTypes.space,
}

Box.defaultProps = {
  variantPath: 'variants',
}

export default Box
